import Vue from 'vue';
import Vuex from 'vuex';
import { navList, area_list, leftMenuList, hot_search, shoppingCartlist } from "@/api/xunyou.js"
import ElementUI from 'element-ui';
import router from '../router';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
  state: {
    airLoading: false,
    shoppingCarNum: localStorage.getItem('carCliType') || 1,
    user: false,
    getprovince: [], // 地址联动
    isShowNav: true,
    gotRedPack: [],
    currentAddress: {},
    erweimaUrl: '',
    logo: "", //全局的logo
    list: [], //购物车的数据
    accountTotal: 0, // 购物车的金额
    totalNumber: 0, // 购物车数量
    copyRight: {}, // 版权相关信息
    userImg: {},
    kjtEnable: {
      enable: true,  // 总开关
      merchant: true, // 店铺是否有快捷通
      H5: true, // 支付宝/微信二维码
    }, // 快捷通开关集合
    // isBaselineVersion:false,
    actednum: '',
    navList: [],
    categoryList: [],  //全部商品分类
    hotSearchList: [],   //热门搜索
    userInfo: JSON.parse(localStorage.getItem('userdata')) || {},
    grayscale: false   //灰度
  },
  mutations: {
    setgrayscale(state, value) {
      state.grayscale = value;
    },
    setShoppingCarNum(state, num) {
      state.shoppingCarNum = num;
      localStorage.setItem('carCliType',num);
    },
    setHotSearchList(state, list) {
      state.hotSearchList = list
    },
    setNavList(state, list) {
      state.navList = list
    },
    setCategoryList(state, list) {
      state.categoryList = list
    },
    changeActednum(state, num) {
      state.actednum = num
    },
    // 登录
    login(state, user) {
      state.user = user;
      localStorage.setItem("userInfo", user);
    },
    // 退出
    logout(state, user) {
      state.user = "";
      localStorage.setItem("userInfo", "");
    },
    // 地址
    getAddress(state, param) {
      state.getprovince = param
    },
    // 是否展示导航栏
    getisShowNav(state, param) {
      state.isShowNav = param
    },
    //  已领取的 为了做对比,防止多次领取
    gotRedPackred(state, param) {
      state.gotRedPack = param
    },
    //  记录当前的位置
    gotCurrentAddress(state, param) {
      state.currentAddress = param
    },
    // 获取微信二维码
    getWxerweima(state, param) {
      state.erweimaUrl = param
    },
    //获取全局的logo
    getLogo(state, params) {
      state.logo = params.pcLogo
    },
    // 获取版权相关信息
    getcopyRight(state, params) {
      state.copyRight = params
    },
    // 获取快捷通 开关集合
    getkjtEnable(state, params) {
      state.kjtEnable = params
    },
    // 查询默认图片
    getUserImg(state, params) {
      state.userImg = params
    },
    // 获取购物车内容
    getCartList(state, params) {
      if (params.length == 0) {
        state.accountTotal = 0
      }
      state.list = params
      let newList = []
      params.forEach((x) => {
        // if (x.bxunyouMerchant) {
        //   x.bxunyouMerchant.normalGood.forEach((y) => {
        //     newList.push(y)
        //   })
        // newList.push(invalidGood)
        // x.bxunyouMerchant.invalidGood.forEach((y)=>{
        //     newList.push(y)
        // })
        // console.log(newList);
        // } else {
        x.bxunyouMerchant.normalGood.forEach((y) => {
          newList.push(y)
        })
        // newList.push(invalidGood)
        // }
      })
      // console.log(newList,"newList---");
      newList.sort((a, b) => {
        return b.cartStatus - a.cartStatus
      })
      state.list = newList;
      // console.log(state.list,"state.list----");

      state.accountTotal = 0
      // let arrList = []
      //  sum = state.list.reduce((sum, item) => {
      //         return Number(sum.member_prie) * sum.number + Number(item.member_prie) * item.number
      //         // return Number(sum) + Number(item.member_prie) * item.number; // 隐式转换
      //     }, 0);
      let sum = 0
      let number = 0
      for (let index = 0; index < state.list.length; index++) {
        sum += Number(state.list[index].member_price) * state.list[index].number
        number += state.list[index].number
      }
      // state.list.forEach((index, item)=>{
      //     number += item.number
      // })
      // console.log(state.list,"state.list");
      state.totalNumber = number
      state.accountTotal += sum;
      // console.log('购物车数据list', state.list)
    }
  },
  //异步执行
  actions: {
    getshoppingCartlist({ commit, state }) {
      state.airLoading = true;
      let agencyAddressFlag = false;  //代发
      if (state.shoppingCarNum == '2') {
        agencyAddressFlag = true;
      }
      // console.log(agencyAddressFlag,"agencyAddressFlag---");
      let partialUserInfo=JSON.parse(localStorage.getItem("userdata"))||{};
      shoppingCartlist({
        uid: partialUserInfo.userId || "",
        userToken: partialUserInfo.userToken || "",
        agencyAddressFlag
      }).then((res) => {
        state.airLoading = false;
        if (res.code == '0') {
          commit("getCartList", res.data);  // 更新购物车
        } else {
          if (res.code == "2001") {
            localStorage.removeItem("userdata");
            router.push("/login")
          }
          ElementUI.Message({
            type: 'warning',
            message: res.msg,
            duration: 2000
          });
        }
      }).catch((err) => {
        state.airLoading = false;
        console.log(err);
      })
    },
    getNavList({ commit }) {
      navList()
        .then((res) => {
          if (res.code == 0) {
            commit('setNavList', res.data);
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAreaList(context) {
      area_list()
        .then(res => {
          if (res.code == 0) {
            context.commit('getAddress', res.data)
          } else {
            console.log(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    getCategoryList({ commit }) {
      leftMenuList()
        .then((res) => {
          if (res.code == 0) {
            commit('setCategoryList', res.data);
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getHotSearchList({ commit }) {
      hot_search()
        .then((res) => {
          if (res.code == 0) {
            var list = res.data.column10.split(",");
            commit('setHotSearchList', list);
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js